@if (!edit){
<div class="d-flex w-100 profile-detail-row">
  <p>
    {{ title | translate }}
  </p>
  <span>{{ control.value }}</span>
</div>
}@else {
<div class="p-0 m-0 w-100">
  <p class="rightHeadings">
    {{ subTitle | translate }}
    @if (required) {<span class="text-danger">*</span>}
  </p>
  <mat-form-field appearance="outline" class="w-100 small">
    <input
      [formControl]="control"
      matInput
      matNativeControl
      placeholder="{{
        placeholder != undefined
          ? (placeholder | translate)
          : (title | translate)
      }}"
    />
  </mat-form-field>
</div>
}
